import DOMPurify, { sanitize } from 'dompurify';

/**
 * Sanitize input and return object prepared
 * for react dangerouslySetInnerHTML
 */
export default function createMarkup(htmlString) {
  if (!htmlString) return;

  if (!DOMPurify.isSupported && !sanitize) {
    // Tests (and older browsers) do not support DOMPurify,
    // so add a fallback to make code run
    return { __html: htmlString };
  }

  return { __html: sanitize(htmlString) };
}

export function isMarkup(string) {
  // Play it safe and only accept strings
  if (typeof string !== 'string') return false;

  // Do a very basic string check - is the first non-whitespace char a "<"?
  return /^\s*<.*$/.test(string);
}
